import { helper } from '@ember/component/helper';

import { get } from 'rise-ui/utils/object.js';

export default helper(function metaGetHelper([ metaArr, index, key ]) {
  return get(metaArr?.[index], key);
});
